let _sessionToken;

export const LOCAL_STORAGE_TOKEN = 'Luft/SessionToken';
const LOCAL_STORAGE_USER_ROLES = 'Luft/UserRoles';
const LOCAL_STORAGE_USER_CLAIMS = 'Luft/UserClaims';
const LOCAL_STORAGE_USER_COMPANY_LOGO = 'Luft/UserCompanyLogo';
export const LOCAL_STORAGE_USER_EMAIL = 'Luft/UserEmail';
export const LOCAL_STORAGE_USER_TYPE = 'Luft/UserType';
const LOCAL_STORAGE_USER_ID = 'Luft/UserId';
const LOCAL_STORAGE_DIVISIONS = 'Luft/CustomerService/Divisions';
const LOCAL_STORAGE_CUSTOMER_SERVICE_COMPANY_ID =
  'Luft/CustomerService/CompanyId';
const LOCAL_STORAGE_CUSTOMER_SERVICE_COMPANY_NAME =
  'Luft/CustomerService/CompanyName';
export const LOCAL_STORAGE_CUSTOMER_SERVICE_COMPANY_DATA =
  'Luft/CustomerService/CompanyData';
export const LOCAL_STORAGE_CUSTOMER_SERVICE_COMPANY_DIVISION =
  'Luft/CustomerService/CompanyDivision';
export const LOCAL_STORAGE_USER_NAME = 'Luft/UserName';
export const LOCAL_STORAGE_COMPANY_NAME = 'Luft/CompanyName';
export const LOCAL_STORAGE_COMPANY_ID = 'Luft/CompanyId';
export const LOCAL_STORAGE_COMPANY_DIVISION = 'Luft/CompanyDivision';

export function saveSession(
  email,
  userType,
  divisions,
  token,
  roles,
  claims,
  companyLogo,
  userId,
  persist = false,
  name,
  companyName,
  companyId,
  companyDivision,
) {
  _sessionToken = token;

  if (persist) {
    window.localStorage.setItem(LOCAL_STORAGE_USER_EMAIL, email);
    window.localStorage.setItem(LOCAL_STORAGE_USER_TYPE, userType);
    window.localStorage.setItem(LOCAL_STORAGE_USER_ID, userId);
    window.localStorage.setItem(LOCAL_STORAGE_DIVISIONS, divisions);
    window.localStorage.setItem(LOCAL_STORAGE_TOKEN, token);
    window.localStorage.setItem(LOCAL_STORAGE_USER_NAME, name);
    window.localStorage.setItem(LOCAL_STORAGE_COMPANY_NAME, companyName);
    window.localStorage.setItem(LOCAL_STORAGE_COMPANY_ID, companyId);
    window.localStorage.setItem(LOCAL_STORAGE_COMPANY_DIVISION, companyDivision);
    window.localStorage.setItem(LOCAL_STORAGE_USER_ROLES, roles.join(','));
    window.localStorage.setItem(LOCAL_STORAGE_USER_CLAIMS, claims.join(','));
    if (companyLogo)
      window.localStorage.setItem(LOCAL_STORAGE_USER_COMPANY_LOGO, companyLogo);
  }
}

export function saveCustomerServiceCompany(companyId, companyName, companyData, companyDivision) {
  window.localStorage.setItem(
    LOCAL_STORAGE_CUSTOMER_SERVICE_COMPANY_ID,
    companyId,
  );
  window.localStorage.setItem(
    LOCAL_STORAGE_CUSTOMER_SERVICE_COMPANY_NAME,
    companyName,
  );
  window.localStorage.setItem(
    LOCAL_STORAGE_CUSTOMER_SERVICE_COMPANY_DIVISION,
    companyDivision,
  );

  if(companyData) {
    window.localStorage.setItem(
      LOCAL_STORAGE_CUSTOMER_SERVICE_COMPANY_DATA,
      JSON.stringify(companyData),
    );
  }
}

export function updateRolesAndClaims(roles, claims) {
  window.localStorage.setItem(LOCAL_STORAGE_USER_ROLES, roles.join(','));
  window.localStorage.setItem(LOCAL_STORAGE_USER_CLAIMS, claims.join(','));
}

export function clearSession() {
  _sessionToken = undefined;
  window.localStorage.removeItem(LOCAL_STORAGE_TOKEN);
  window.localStorage.removeItem(LOCAL_STORAGE_USER_ROLES);
  window.localStorage.removeItem(LOCAL_STORAGE_USER_CLAIMS);
  window.localStorage.removeItem(LOCAL_STORAGE_USER_COMPANY_LOGO);
  window.localStorage.removeItem(LOCAL_STORAGE_USER_EMAIL);
  window.localStorage.removeItem(LOCAL_STORAGE_USER_TYPE);
  window.localStorage.removeItem(LOCAL_STORAGE_USER_ID);
  window.localStorage.removeItem(LOCAL_STORAGE_CUSTOMER_SERVICE_COMPANY_ID);
  window.localStorage.removeItem(LOCAL_STORAGE_CUSTOMER_SERVICE_COMPANY_NAME);
  window.localStorage.removeItem(LOCAL_STORAGE_CUSTOMER_SERVICE_COMPANY_DIVISION);
}

export function getSessionToken() {
  if (!_sessionToken) {
    _sessionToken = window.localStorage.getItem(LOCAL_STORAGE_TOKEN) || '';
  }

  return _sessionToken;
}

export function getSessionUser() {
  const roles = window.localStorage.getItem(LOCAL_STORAGE_USER_ROLES);
  const claims = window.localStorage.getItem(LOCAL_STORAGE_USER_CLAIMS);
  const companyLogo = window.localStorage.getItem(
    LOCAL_STORAGE_USER_COMPANY_LOGO,
  );

  return {
    roles: roles ? roles.split(',').map(Number) : [],
    claims: claims ? claims.split(',').map(Number) : [],
    companyLogo,
  };
}
